import { SCHEDULE_TASK_TYPES } from "./components/constants";

const validateRequired = (value) => !!value?.length;
export const categories = ["Software", "Engineering", "Website", "Marketing"];
export const sidebarWidth = "200px";
export function validateProject(project) {
  return {
    projectName: !validateRequired(project.projectName)
      ? "Project Name is Required"
      : "",
  };
}

export function validateTask(task) {
  const errors = {};

  // Validate task name
  if (!validateRequired(task.task)) {
    errors.task = "Task Name is Required";
  }

  // Validate type
  if (!validateRequired(task.type)) {
    errors.type = "Type is Required";
  } else if (!SCHEDULE_TASK_TYPES.includes(String(task.type).toLowerCase())) {
    errors.type = "Type must be Engineering, Procurement, Fabrication, or ITP";
  }

  // Validate priority
  if (!validateRequired(task.priority)) {
    errors.priority = "Priority is Required";
  } else if (!["High", "Medium", "Low"].includes(task.priority)) {
    errors.priority = "Priority must be High, Medium, or Low";
  }

  // Validate status
  if (!validateRequired(task.status)) {
    errors.status = "Status is Required";
  } else if (
    !["Not Started", "Progress", "Hold", "Completed", "Delayed"].includes(
      task.status,
    )
  ) {
    errors.status = "Invalid status value";
  }

  // Validate end date
  if (task.endDate) {
    const endDate = new Date(task.endDate);
    if (isNaN(endDate.getTime())) {
      errors.endDate = "Invalid date format";
    }
  }

  // Also check targetDate if it exists (for backward compatibility)
  if (task.targetDate && !task.endDate) {
    const targetDate = new Date(task.targetDate);
    if (isNaN(targetDate.getTime())) {
      errors.targetDate = "Invalid date format";
    }
  }

  // Validate estimated time (should be a number if provided)
  if (
    task.estimatedTime !== undefined &&
    task.estimatedTime !== null &&
    task.estimatedTime !== ""
  ) {
    const estimatedTime = Number(task.estimatedTime);
    if (isNaN(estimatedTime) || estimatedTime < 0) {
      errors.estimatedTime = "Estimated time must be a positive number";
    }
  }

  return errors;
}

export function validateTimesheet(timesheet) {
  return {
    timesheet: !validateRequired(timesheet.workDone || timesheet.remarks)
      ? "Details is Required"
      : "",
  };
}

export function validateUser(user) {
  return {
    user: !validateRequired(user.username) ? "User Name is Required" : "",
  };
}
